import type { QuestionOption } from '../../lib/assessment/types'

export const EMIRATE_OPTIONS: QuestionOption[] = [
  { value: 'abu_dhabi', label: 'Abu Dhabi' },
  { value: 'dubai', label: 'Dubai' },
  { value: 'sharjah', label: 'Sharjah' },
  { value: 'ajman', label: 'Ajman' },
  { value: 'umm_al_quwain', label: 'Umm Al Quwain' },
  { value: 'ras_al_khaimah', label: 'Ras Al Khaimah' },
  { value: 'fujairah', label: 'Fujairah' },
  { value: 'multiple', label: 'Multiple emirates' },
  { value: 'other', label: 'Other or not sure' },
]

export const COMPANY_SIZE_OPTIONS: QuestionOption[] = [
  { value: 'under_50', label: 'Under 50 employees' },
  { value: '50_99', label: '50–99 employees' },
  { value: '100_249', label: '100–249 employees' },
  { value: '250_999', label: '250–999 employees' },
  { value: '1000_plus', label: '1,000 or more employees' },
  { value: 'not_sure', label: 'Not sure' },
]

export const SECTOR_OPTIONS: QuestionOption[] = [
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'construction', label: 'Construction and engineering' },
  { value: 'real_estate', label: 'Real estate and property management' },
  { value: 'logistics', label: 'Logistics, transport and warehousing' },
  { value: 'oil_gas_energy', label: 'Oil, gas and energy' },
  { value: 'hospitality', label: 'Hospitality, tourism and food services' },
  { value: 'retail', label: 'Retail and wholesale' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'financial_services', label: 'Financial services and insurance' },
  { value: 'technology_services', label: 'Technology and professional services' },
  { value: 'agriculture', label: 'Agriculture and food production' },
  { value: 'other', label: 'Other' },
]

export const LISTING_STATUS_OPTIONS: QuestionOption[] = [
  { value: 'adx', label: 'Listed on ADX' },
  { value: 'dfm', label: 'Listed on DFM' },
  { value: 'both', label: 'Listed on both ADX and DFM' },
  { value: 'preparing_ipo', label: 'Preparing for an IPO' },
  { value: 'not_listed', label: 'Not listed' },
  { value: 'not_sure', label: 'Not sure' },
]

export const FOOTPRINT_OPTIONS: QuestionOption[] = [
  { value: 'single_site', label: 'Single site / facility' },
  { value: 'multi_site_same_emirate', label: 'Multiple sites in one emirate' },
  { value: 'multi_emirate', label: 'Operations in more than one emirate' },
  { value: 'uae_and_international', label: 'UAE plus international operations' },
  { value: 'not_sure', label: 'Not sure' },
]

export const BUSINESS_ACTIVITY_OPTIONS: QuestionOption[] = [
  { value: 'owns_fleet', label: 'Owns or controls vehicles / mobile equipment' },
  { value: 'owns_buildings', label: 'Owns or manages buildings' },
  { value: 'industrial_process', label: 'Industrial or process operations' },
  { value: 'imports_exports', label: 'Imports or exports goods' },
  { value: 'serves_multinationals', label: 'Supplies multinational customers' },
  { value: 'uses_refrigerants', label: 'Uses significant cooling / refrigerants' },
  { value: 'generates_waste', label: 'Generates material operational waste' },
  { value: 'investment_portfolio', label: 'Manages investment or financing portfolios' },
]

export const REVENUE_BAND_OPTIONS: QuestionOption[] = [
  { value: 'under_10m', label: 'Under AED 10 million' },
  { value: '10_50m', label: 'AED 10–50 million' },
  { value: '50_250m', label: 'AED 50–250 million' },
  { value: '250m_plus', label: 'AED 250 million or more' },
  { value: 'not_sure', label: 'Prefer not to say / not sure' },
]

export const MAINLAND_FREEZONE_OPTIONS: QuestionOption[] = [
  { value: 'mainland', label: 'Mainland' },
  { value: 'freezone', label: 'Free zone' },
  { value: 'both', label: 'Both' },
  { value: 'not_sure', label: 'Not sure' },
]

export const EXPORT_MARKET_OPTIONS: QuestionOption[] = [
  { value: 'eu', label: 'European Union' },
  { value: 'uk', label: 'United Kingdom' },
  { value: 'gcc', label: 'Other GCC' },
  { value: 'asia', label: 'Asia' },
  { value: 'americas', label: 'Americas' },
  { value: 'none', label: 'No material exports' },
  { value: 'not_sure', label: 'Not sure' },
]

export const TRI_OPTIONS: QuestionOption[] = [
  { value: 'yes', label: 'Yes' },
  { value: 'no', label: 'No' },
  { value: 'not_sure', label: 'Not sure' },
]
